// extracted by mini-css-extract-plugin
module.exports = {"container":"SetPasswordLayout_container__3sQwJ","header":"SetPasswordLayout_header__2g8Nc","logo":"SetPasswordLayout_logo__1Zt_X"};